import clsx from 'clsx';
import React from 'react';
import POSAnimatedImage from '../POSAnimatedImage';
import './POSLoadingIndicator.less';

export type Props = {
  className?: string;
  text?: React.ReactNode;
  inverted?: boolean;
  height?: string;
};

export const POSLoadingIndicator: React.VFC<Props> = ({
  className,
  text,
  inverted,
  height,
}) => {
  return (
    <div
      className={clsx(className, 'pos-loading-indicator', {
        inverted: inverted,
      })}
      style={height ? { height: height } : {}}
    >
      <POSAnimatedImage image={!inverted ? 'LoadingBlack' : 'LoadingWhite'} />
      {text && <div>{text}</div>}
    </div>
  );
};
